<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PagesQueries from '@Pages/Domain/queries-vue-component';
    import PagesCommands from '@Pages/Domain/commands-vue-component';
    import { RequestPageViewerPageReadModel } from '@Pages/Domain/readmodels';
    import AlternativeEditor from '@Alternatives/Alternatives/Components/AlternativeEditor.vue';
    import { AlternativeAttributeValueDTO } from '@Alternatives/Model';
    import AlternativesCommands from '@Alternatives/Alternatives/Domain/commands-vue-component';
    import { guid } from '@common/Guid';
    import { CreateAlternativeCommandV1 } from '@Alternatives/Alternatives/Domain/commands-core';
    import { ValidationError } from '@common/types';
    import { ICommandBase } from '@Pages/cqrs';

    @Component({
        components: { AlternativeEditor }
    })
    export default class RequestPageViewerPage extends mixins(PagesQueries, PagesCommands, AlternativesCommands)
    {
        get accessKey() { return this.$route.params.accessKey; }

        rm: RequestPageViewerPageReadModel = null;
        errors: ValidationError[] = null;
        isConfirmationVisible: boolean = false;

        save(name: string, description: string, statusId: number, attributeValues: AlternativeAttributeValueDTO[])
        {
            this.validationErrors = null;
            this.invokeCreateAlternativeCommandV1(this.rm.UserId, this.rm.WorkspaceId, this.rm.ProjectId, this.rm.AlternativesListId, this.rm.FormId, guid(), name, description, statusId, attributeValues);
        }

        reload()
        {
            window.location.reload();
        }

        mounted()
        {   
            document.title = "Request page | TransparentChoice";
            this.runRequestPageViewerPageQueryV1(this.accessKey);
        }


        onSetModel(model: any, modelName: string) 
        {
            if (modelName == "RequestPageViewerPageReadModel")
            {
                this.rm = model as RequestPageViewerPageReadModel;
                document.title = `Request new ${this.rm.AlternativeLabel} | TransparentChoice`;
            }
        }

        onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
        {
            if (CreateAlternativeCommandV1.matchType(cmd))
            {
                this.isConfirmationVisible = true;
            }
        }

        onCommandFailed(status: any)
        {
            if (CreateAlternativeCommandV1.matchType(status.Command))
            {
                this.errors = status.ValidationErrors;
            }
        }
    }
</script>

<template>
    <div v-if="rm">
        <template v-if="isConfirmationVisible === true">
            <div class="d-flex justify-content-center" style="padding-top: 200px;">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Thank you!</h5>
                        <p class="card-text lead">We've got your request. Do you want to add another?</p><br />
                        <button @click="reload" type="button" class="btn btn-primary">Add another</button>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="isConfirmationVisible === false">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10 col-md-12 offset-lg-1">
                        <img :src="rm.LogoUrl" style="margin-top: 15px;" />
                        <br /><br />
                        <div v-html="rm.ContentHtml"></div>
                        <br />
                        <AlternativeEditor v-if="rm" :propRm="rm.AlternativeEditor" :propErrors="errors" propFormId="requestPageAlternativeForm"
                                           @form-submit="save" />
                        <br />
                        <br />
                        <button type="submit" form="requestPageAlternativeForm" class="btn btn-primary">Confirm</button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>